// @flow

import React, { type Node } from  'react';
import { Cell, Title, Value, ValueSmall } from './ticket';
import { formatDueDate } from '@tectonics/prs/nequi';
import { getWeekDayByCountry } from '@tectonics/prs/week-day';

import { 
  usePendingIncomingPayment, 
  getPaymentTypeCode, 
  getNequiExpirationDatetime,
  getCountry,
} from '@tectonics/prs/incoming-payment';

export function VoucherTicketDueDateTime(): Node {
  return (
    <Cell>
      <Title>
        <TitleContent />
      </Title>

      <Value style={{ flexDirection: 'column' }}>
        <DueDateContent />
        <ValueSmall>
          <AdditionalText />
        </ValueSmall>
      </Value>
    </Cell>
  );
}

function TitleContent(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const paymentTypeCode = getPaymentTypeCode(incomingPayment);

  switch (paymentTypeCode) {
    case 'nequi':
      return 'Fecha y hora de expiración';

    default:
      throw new Error('Voucher Ticket Due Date Title - Not implemented yet');
  }
}

function DueDateContent(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const paymentTypeCode = getPaymentTypeCode(incomingPayment);
  const expirationDateTime = getNequiExpirationDatetime(usePendingIncomingPayment());

  switch (paymentTypeCode) {
    case 'nequi':
      return formatDueDate(expirationDateTime);

    default:
      throw new Error('Voucher Ticket Due Date Content - Not implemented yet');
  }
}

function AdditionalText(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);
  const paymentTypeCode = getPaymentTypeCode(incomingPayment);
  const expirationDateTime = getNequiExpirationDatetime(incomingPayment);
  const dueDate = extractOnlyDate(expirationDateTime);

  switch (paymentTypeCode) {
    case 'nequi':
      return `Paga hasta ${getWeekDayByCountry(dueDate, country)}`;

    default:
      throw new Error('Voucher Ticket Due Date Additional Text - Not implemented yet');
  }
}

function extractOnlyDate(dateTime: string): string {
  const dateMatches = dateTime.match(/(\d{4}-\d{1,2}-\d{1,2})/);
  
  if (!dateMatches) {
    throw new Error('Failed to extract date from string');
  }

  return dateMatches[1];
}
